// src/utils/stateLegislatorUrls.ts
export interface StateLegislatorUrl {
  state: string;
  stateUrlFindLeg: string;
  stateLegUrl: string;
}

export const stateLegislatorUrls: StateLegislatorUrl[] = [
  {
    state: 'Alabama',
    stateUrlFindLeg: 'https://www.sos.alabama.gov/alabama-votes/elected-official-map',
    stateLegUrl: 'https://alison.legislature.state.al.us',
  },
  {
    state: 'Alaska',
    stateUrlFindLeg: 'https://akleg.gov/',
    stateLegUrl: 'https://akleg.gov',
  },
  {
    state: 'Arizona',
    stateUrlFindLeg: 'https://www.azleg.gov/memberroster/',
    stateLegUrl: 'https://www.azleg.gov',
  },
  {
    state: 'Arkansas',
    stateUrlFindLeg: 'https://www.arkleg.state.ar.us/Legislators/List',
    stateLegUrl: 'https://www.arkleg.state.ar.us',
  },
  {
    state: 'California',
    stateUrlFindLeg: 'https://findyourrep.legislature.ca.gov/',
    stateLegUrl: 'https://findyourrep.legislature.ca.gov',
  },
  {
    state: 'Colorado',
    stateUrlFindLeg: 'https://leg.colorado.gov/find-my-legislator',
    stateLegUrl: 'https://leg.colorado.gov',
  },
  {
    state: 'Connecticut',
    stateUrlFindLeg: 'https://www.cga.ct.gov/asp/menu/cgafindleg.asp',
    stateLegUrl: 'https://www.cga.ct.gov',
  },
  {
    state: 'Delaware',
    stateUrlFindLeg: 'https://legis.delaware.gov/FindMyLegislator',
    stateLegUrl: 'https://legis.delaware.gov',
  },
  {
    state: 'Florida',
    stateUrlFindLeg: 'https://www.myfloridahouse.gov/FindYourRepresentative',
    stateLegUrl: 'https://www.myfloridahouse.gov',
  },
  {
    state: 'Georgia',
    stateUrlFindLeg: 'https://www.legis.ga.gov/members/find-your-legislator',
    stateLegUrl: 'https://www.legis.ga.gov',
  },
  {
    state: 'Hawaii',
    stateUrlFindLeg: 'https://www.capitol.hawaii.gov/fylhome.aspx',
    stateLegUrl: 'https://www.capitol.hawaii.gov',
  },
  {
    state: 'Idaho',
    stateUrlFindLeg: 'https://legislature.idaho.gov/legislators/whosmylegislator/',
    stateLegUrl: 'https://legislature.idaho.gov',
  },
  {
    state: 'Illinois',
    stateUrlFindLeg: 'https://experience.arcgis.com/experience/b62f98ad44314d18ade2545833aa498a/',
    stateLegUrl: 'https://www.ilga.gov',
  },
  {
    state: 'Indiana',
    stateUrlFindLeg: 'https://iga.in.gov/legislative/find-legislators/',
    stateLegUrl: 'https://iga.in.gov',
  },
  {
    state: 'Iowa',
    stateUrlFindLeg: 'https://www.legis.iowa.gov/legislators/find',
    stateLegUrl: 'https://www.legis.iowa.gov',
  },
  {
    state: 'Kansas',
    stateUrlFindLeg: 'https://ksleglookup.org/#/',
    stateLegUrl: 'https://www.kslegislature.org',
  },
  {
    state: 'Kentucky',
    stateUrlFindLeg: 'https://apps.legislature.ky.gov/findyourlegislator/findyourlegislator.html',
    stateLegUrl: 'https://legislature.ky.gov',
  },
  {
    state: 'Louisiana',
    stateUrlFindLeg: 'https://www.legis.la.gov/legis/FindMyLegislators.aspx',
    stateLegUrl: 'https://www.legis.la.gov',
  },
  {
    state: 'Maine',
    stateUrlFindLeg: 'https://legislature.maine.gov/house/house/MemberProfiles/find-your-representative',
    stateLegUrl: 'https://legislature.maine.gov',
  },
  {
    state: 'Maryland',
    stateUrlFindLeg: 'https://mgaleg.maryland.gov/mgawebsite/Members/Find',
    stateLegUrl: 'https://mgaleg.maryland.gov',
  },
  {
    state: 'Massachusetts',
    stateUrlFindLeg: 'https://malegislature.gov/Search/FindMyLegislator',
    stateLegUrl: 'https://malegislature.gov',
  },
  {
    state: 'Michigan',
    stateUrlFindLeg: 'https://www.house.mi.gov/repLocator.aspx',
    stateLegUrl: 'https://www.house.mi.gov',
  },
  {
    state: 'Minnesota',
    stateUrlFindLeg: 'https://www.gis.lcc.mn.gov/iMaps/districts/',
    stateLegUrl: 'https://www.gis.lcc.mn.gov',
  },
  {
    state: 'Mississippi',
    stateUrlFindLeg: 'https://www.legislature.ms.gov/legislators/',
    stateLegUrl: 'https://www.legislature.ms.gov',
  },
  {
    state: 'Missouri',
    stateUrlFindLeg: 'https://house.mo.gov/legislatorlookup.aspx',
    stateLegUrl: 'https://house.mo.gov',
  },
  {
    state: 'Montana',
    stateUrlFindLeg: 'https://leg.mt.gov/legislator-lookup/',
    stateLegUrl: 'https://leg.mt.gov',
  },
  {
    state: 'Nebraska',
    stateUrlFindLeg: 'https://nebraskalegislature.gov/senators/senator_find.php',
    stateLegUrl: 'https://nebraskalegislature.gov',
  },
  {
    state: 'Nevada',
    stateUrlFindLeg: 'https://www.leg.state.nv.us/App/Legislator/A/',
    stateLegUrl: 'https://www.leg.state.nv.us',
  },
  {
    state: 'New Hampshire',
    stateUrlFindLeg: 'https://www.gencourt.state.nh.us/house/members/wml.aspx',
    stateLegUrl: 'https://www.gencourt.state.nh.us',
  },
  {
    state: 'New Jersey',
    stateUrlFindLeg: 'https://www.njleg.state.nj.us/legislative-roster',
    stateLegUrl: 'https://www.njleg.state.nj.us',
  },
  {
    state: 'New Mexico',
    stateUrlFindLeg: 'https://www.nmlegis.gov/Members/Find_My_Legislator',
    stateLegUrl: 'https://www.nmlegis.gov',
  },
  {
    state: 'New York',
    stateUrlFindLeg: 'https://nyassembly.gov/mem/search/',
    stateLegUrl: 'https://nyassembly.gov',
  },
  {
    state: 'North Carolina',
    stateUrlFindLeg: 'https://www.ncleg.gov/findyourlegislators',
    stateLegUrl: 'https://www.ncleg.gov',
  },
  {
    state: 'North Dakota',
    stateUrlFindLeg: 'https://www.ndlegis.gov/assembly/find-your-legislator',
    stateLegUrl: 'https://www.ndlegis.gov',
  },
  {
    state: 'Ohio',
    stateUrlFindLeg: 'https://www.legislature.ohio.gov/members/district-maps',
    stateLegUrl: 'https://www.legislature.ohio.gov',
  },
  {
    state: 'Oklahoma',
    stateUrlFindLeg: 'https://www.oklegislature.gov/findmylegislature.aspx',
    stateLegUrl: 'https://www.oklegislature.gov',
  },
  {
    state: 'Oregon',
    stateUrlFindLeg: 'https://www.oregonlegislature.gov/FindYourLegislator',
    stateLegUrl: 'https://www.oregonlegislature.gov',
  },
  {
    state: 'Pennsylvania',
    stateUrlFindLeg: 'https://www.legis.state.pa.us/cfdocs/legis/home/findyourlegislator/',
    stateLegUrl: 'https://www.legis.state.pa.us',
  },
  {
    state: 'Rhode Island',
    stateUrlFindLeg: 'https://vote.sos.ri.gov/Home/PollingPlaces?ActiveFlag=3',
    stateLegUrl: 'https://www.rilegislature.gov',
  },
  {
    state: 'South Carolina',
    stateUrlFindLeg: 'https://www.scstatehouse.gov/legislatorssearch.php',
    stateLegUrl: 'https://www.scstatehouse.gov',
  },
  {
    state: 'South Dakota',
    stateUrlFindLeg: 'https://sdlegislature.gov/Legislators/Find',
    stateLegUrl: 'https://sdlegislature.gov',
  },
  {
    state: 'Tennessee',
    stateUrlFindLeg: 'https://www.capitol.tn.gov/legislators/',
    stateLegUrl: 'https://www.capitol.tn.gov',
  },
  {
    state: 'Texas',
    stateUrlFindLeg: 'https://wrm.capitol.texas.gov/home',
    stateLegUrl: 'https://wrm.capitol.texas.gov',
  },
  {
    state: 'Utah',
    stateUrlFindLeg: 'https://le.utah.gov/GIS/findDistrict.jsp',
    stateLegUrl: 'https://le.utah.gov',
  },
  {
    state: 'Vermont',
    stateUrlFindLeg: 'https://legislature.vermont.gov/people/search/lookup',
    stateLegUrl: 'https://legislature.vermont.gov',
  },
  {
    state: 'Virginia',
    stateUrlFindLeg: 'https://whosmy.virginiageneralassembly.gov/',
    stateLegUrl: 'https://whosmy.virginiageneralassembly.gov',
  },
  {
    state: 'Washington',
    stateUrlFindLeg: 'https://app.leg.wa.gov/DistrictFinder/',
    stateLegUrl: 'https://app.leg.wa.gov',
  },
  {
    state: 'West Virginia',
    stateUrlFindLeg: 'https://www.wvlegislature.gov/legisdocs/Find_Your_Legislator.cfm',
    stateLegUrl: 'https://www.wvlegislature.gov',
  },
  {
    state: 'Wisconsin',
    stateUrlFindLeg: 'https://maps.legis.wisconsin.gov/',
    stateLegUrl: 'https://maps.legis.wisconsin.gov',
  },
  {
    state: 'Wyoming',
    stateUrlFindLeg: 'https://www.wyoleg.gov/Legislators',
    stateLegUrl: 'https://www.wyoleg.gov',
  },
];
